<template>
  <el-container class="page-x" direction="vertical">
    <div class="search-x">
      <p class="title">体检报告列表</p>
      <el-button @click="$router.go(-1)" size="mini">返回</el-button>
    </div>
    <div class="cont-x">
      <div class="table-x" ref="tableBox">
        <el-table v-loading="loading" :data="tableData" border class="mb20">
          <el-table-column type="index" align="center" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="导入时间">
          </el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单号">
          </el-table-column>
          <el-table-column
            prop="thirdOrderNo"
            align="center"
            label="三方订单号"
          >
          </el-table-column>
          <el-table-column
            prop="reportSourceName"
            align="center"
            label="检查机构"
          >
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="middle"
                class="mb10"
                type="text"
                @click="toDetail(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchBox.pageNum"
          :page-size="searchBox.pageSize"
          layout="total,  prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </div>
  </el-container>
</template>
<script>
const _sourceList = [
  { label: "爱康", id: "AIKANG" },
  { label: "其他", id: "MJK" },
  { label: "", id: "KONG" },
];
const _physicalSource = [
  { label: "核保体检", value: 1 },
  { label: "健康体检", value: 2 },
  { label: "手动上传", value: 3 },
  { label: "官微", value: 4 },
  { label: "企微", value: 5 },
];
import { isArray, dateFormat } from "@/assets/js/until.js";
export default {
  data() {
    return {
      loading: false,
      // 查询条件
      timeRange: [],
      searchBox: {
        pageSize: 10,
        pageNo: 1,
        userId: this.$store.state.healthDocUser.userId, // 关键字（用户ID,姓名、手机号、证件号）
      },
      sourceList: _sourceList,
      physicalSource: _physicalSource,
      tableData: [],
      total: 0,
    };
  },
  filters: {
    filterValue(text, data) {
      return (
        data.find((item) => {
          if (text == item.value) {
            return item;
          }
        })?.label || text
      );
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    num2Text(id, keyName) {
      if (this[keyName] && isArray(this[keyName])) {
        let findItem = this[keyName].find((o) => o.id === id);
        return findItem["label"] || "";
      } else {
        return id;
      }
    },
    toSearch() {
      this.searchBox.pageNo = 1;
      // window.alert(JSON.stringify(this.searchBox))
      this.getData();
    },
    getData() {
      let apiName = "examReportDetailList";
      let data = { ...this.searchBox };
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let { code, msg, data } = res;
          if (code === 1) {
            this.total = data.total;
            this.tableData = data.data || [];
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {});
    },
    handleSizeChange(val) {
      this.searchBox.pageNo = 1;
      this.searchBox.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.searchBox.pageNo = val;
      this.getData();
    },
    toDetail(item) {
      if (item.reportSource == "KONG") item.reportSource = "MJK";
      if (item.reportSource) {
        let query = {
          id: item.bookingId,
          orderNo: item.orderNo,
          reportSource: item.reportSource,
          source: item.source,
          pathSource: !this.$store.state.healthDocUser.isDoc
            ? "用户管理,用户档案,报告详情"
            : "健康档案,报告详情",
        };
        this.$router.push({
          name: "ReportDetail",
          query,
        });
      } else {
        this.$message({
          type: "warning",
          message: "暂不支持此类型报告",
        });
      }
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.search-x {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.cont-x {
  flex: 1;
  flex-shrink: 0;
}
</style>
